import { components } from 'react-select';

const RecipientSingleValue = (props: any) => {
  const { data } = props;
  return (
    <components.SingleValue {...props}>
      <div className="recipient-single-value">
        <div className="navbar-user">
          <div className="oath-body">{data.label}</div>
          {data.subtitle ? <div className="oath-utility">{data.subtitle}</div> : null}
        </div>
      </div>
    </components.SingleValue>
  );
};

export default RecipientSingleValue;
